import { Inject, Component } from '@angular/core';
import { CUSTOM_CHIP_DATA } from 'common/types/chip-data';
import { AssociationController } from 'src/features/common/association/association.controller';

@Component({
  templateUrl: 'dialog-chip.component.html',
})
export class DialogChipComponent {

  public valueProperty: string;
  public viewValueProperty: string;

  constructor(
    @Inject(CUSTOM_CHIP_DATA) public item: any,
    public associationController: AssociationController
  ) {
    this.valueProperty = this.associationController.model.modalChipValueProperty || 'id';
    this.viewValueProperty = this.associationController.model.modalChipViewValueProperty
      || (this.associationController.model.primaryKey
        ? this.associationController.model.primaryKey.replace(/Cd$/g, 'Name')
        : 'name');
  }
}
